import { enqueueSnackbar } from "notistack";

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
  enqueueSnackbar(`Copied ${text} to clipboard`, { variant: "success" });
}
